import { render, staticRenderFns } from "./SurveySettings.vue?vue&type=template&id=493c3100&"
import script from "./SurveySettings.vue?vue&type=script&lang=js&"
export * from "./SurveySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports